import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "hylas_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const api = {
  submitApplication: (data) => axios.post(`${API}/applications`, data).then((r) => r.data),
  uploadFile: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/upload`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
  adminLogin: (username, password) => axios.post(`${API}/admin/login`, { username, password }).then((r) => r.data),
  listApplications: () => axios.get(`${API}/applications`, { headers: authHeader() }).then((r) => r.data),
  applicationStats: () => axios.get(`${API}/applications/stats`, { headers: authHeader() }).then((r) => r.data),
  getFile: (path) =>
    axios.get(`${API}/files/${path}`, {
      headers: authHeader(),
      responseType: "blob",
    }).then((r) => r.data),
  trackApplication: (q) =>
    axios.get(`${API}/track`, { params: { q } }).then((r) => r.data),
  updateApplicationStatus: (id, status) =>
    axios.patch(`${API}/applications/${id}/status`, { status }, { headers: authHeader() }).then((r) => r.data),
  clearSignaturePath: (id) =>
    axios.patch(`${API}/applications/${id}/clear-signature`, {}, { headers: authHeader() }).then((r) => r.data),
  exportApplications: () =>
    axios.get(`${API}/applications/export`, {
      headers: authHeader(),
      responseType: "blob",
    }).then((r) => r.data),
  listIntroductions: () =>
    axios.get(`${API}/introductions`, { headers: authHeader() }).then((r) => r.data),
  createIntroduction: (data) =>
    axios.post(`${API}/introductions`, data, { headers: authHeader() }).then((r) => r.data),
  deleteIntroduction: (id) =>
    axios.delete(`${API}/introductions/${id}`, { headers: authHeader() }).then((r) => r.data),
  updateApplicationFleet: (id, fleet) =>
    axios.patch(`${API}/applications/${id}/fleet`, { current_fleet: fleet }, { headers: authHeader() }).then((r) => r.data),
  updateIntroduction: (id, data) =>
    axios.put(`${API}/introductions/${id}`, data, { headers: authHeader() }).then((r) => r.data),
  getDriverProfilePDF: (id) =>
    axios.get(`${API}/applications/${id}/pdf`, {
      headers: authHeader(),
      responseType: "blob",
    }).then((r) => r.data),
  submitChatLead: (data) =>
    axios.post(`${API}/chat-leads`, data).then((r) => r.data),
  listChatLeads: () =>
    axios.get(`${API}/chat-leads`, { headers: authHeader() }).then((r) => r.data),
  deleteChatLead: (id) =>
    axios.delete(`${API}/chat-leads/${id}`, { headers: authHeader() }).then((r) => r.data),
  revealSSN: (id) =>
    axios.post(`${API}/applications/${id}/reveal-ssn`, {}, { headers: authHeader() }).then((r) => r.data),
  migrateSSNEncryption: () =>
    axios.post(`${API}/admin/migrate-ssn-encryption`, {}, { headers: authHeader() }).then((r) => r.data),

  // ── Market ──────────────────────────────────────────────────────────────
  marketSetupStatus: () => axios.get(`${API}/market/setup-status`).then((r) => r.data),
  marketSetup: (data) => axios.post(`${API}/market/setup`, data).then((r) => r.data),
  marketLogin: (data) => axios.post(`${API}/market/hub/login`, data).then((r) => r.data),
  marketVerifyToken: (token) =>
    axios.get(`${API}/market/verify-token`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAcceptTerms: (token) =>
    axios.post(`${API}/market/terms/accept`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketChangePassword: (token, hub, new_password, new_username) =>
    axios.put(`${API}/market/admin/change-password`, { hub, new_password, new_username }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketGetDrivers: () =>
    axios.get(`${API}/market/drivers`).then((r) => r.data),
  marketGetBids: () =>
    axios.get(`${API}/market/bids`).then((r) => r.data),
  marketGetDriverBids: (driverId) =>
    axios.get(`${API}/market/bids/${driverId}`).then((r) => r.data),
  marketPlaceBid: (token, data) =>
    axios.post(`${API}/market/bids`, data, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketWeeklyFlexSubscribe: (token, data) =>
    axios.post(`${API}/market/carrier/weekly-flex-subscribe`, data, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminInjectFakeBid: (token, data) =>
    axios.post(`${API}/market/admin/inject-fake-bid`, data, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminClearFakeBids: (token) =>
    axios.delete(`${API}/market/admin/fake-bids`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminFakeBidCount: (token) =>
    axios.get(`${API}/market/admin/fake-bids/count`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminCarrierStats: (token) =>
    axios.get(`${API}/market/admin/carrier-stats`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminSubmitIndexNow: (token) =>
    axios.post(`${API}/market/admin/submit-indexnow`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminManualTransfer: (token, driver_id, carrier_name, notes = "", placement_fee = 0) =>
    axios.post(`${API}/market/admin/manual-transfer`, { driver_id, carrier_name, notes, placement_fee }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminPatchBidFee: (token, bid_id, fee) =>
    axios.patch(`${API}/market/admin/bids/${bid_id}/set-fee`, { fee }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminPatchBidFeeByDriver: (token, driver_name, carrier_name, fee) =>
    axios.post(`${API}/market/admin/bids/patch-fee-by-driver`, { driver_name, carrier_name, fee }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminCarrierAgreements: (token) =>
    axios.get(`${API}/market/admin/carrier-agreements`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminDriverAgreements: (token) =>
    axios.get(`${API}/market/admin/driver-agreements`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminStaffAgreements: (token) =>
    axios.get(`${API}/market/admin/staff-agreements`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminSaveStaffAgreement: (token, data) =>
    axios.post(`${API}/market/admin/staff-agreements`, data, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminDeleteStaffAgreement: (token, id) =>
    axios.delete(`${API}/market/admin/staff-agreements/${id}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminRevokeCarrierAgreement: (token, phone) =>
    axios.delete(`${API}/market/admin/carrier-agreements/${encodeURIComponent(phone)}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminToggleCarrierVisibility: (token, phone, show) =>
    axios.patch(`${API}/market/admin/carrier-agreements/${encodeURIComponent(phone)}/visibility`, { show }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  getPublicPartners: () =>
    axios.get(`${API}/market/public/partners`).then((r) => r.data),
  marketAdminArchiveDriverAgreement: (token, driverId) =>
    axios.delete(`${API}/market/admin/driver-agreements/${driverId}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketDeleteMedicalPage: (token, appId, pageIndex) =>
    axios.delete(`${API}/market/safety/drivers/${appId}/medical-page/${pageIndex}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketCarrierTransferAlerts: (token) =>
    axios.get(`${API}/market/carrier/transfer-alerts`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketDriverUpdateProfile: (token, data) =>
    axios.put(`${API}/market/driver/profile`, data, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketUpdateBidStatus: (token, bidId, status) =>
    axios.put(`${API}/market/bids/${bidId}/status`, { status }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketDeleteBid: (token, bidId) =>
    axios.delete(`${API}/market/bids/${bidId}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAnnulTransfer: (token, bidId, reason, notes) =>
    axios.post(`${API}/market/admin/transfers/${bidId}/annul`, { reason, notes }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAcknowledgeAnnulment: (token, notifId) =>
    axios.post(`${API}/market/carrier/acknowledge-annulment/${notifId}`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketGetAnnulmentHistory: (token) =>
    axios.get(`${API}/market/carrier/annulment-history`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketCarrierUploadDoc: (token, appId, docType, file) => {
    const fd = new FormData(); fd.append("doc_type", docType); fd.append("file", file);
    return axios.post(`${API}/market/carrier/drivers/${appId}/upload-doc`, fd, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
  },
  marketCarrierDocCredits: (token) =>
    axios.get(`${API}/market/carrier/doc-credits`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminGetAnnulments: (token, page = 1, sortBy = "created_at", sortDir = -1) =>
    axios.get(`${API}/market/admin/annulments`, { params: { page, sort_by: sortBy, sort_dir: sortDir }, headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminExportAnnulmentsCSV: (token) =>
    axios.get(`${API}/market/admin/annulments/export-csv`, { responseType: "blob", headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketCounterOffer: (token, bidId, suggestedFee) =>
    axios.post(`${API}/market/bids/${bidId}/counter-offer`, { suggested_fee: suggestedFee }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketTransferDriver: (token, appId, bidId) =>
    axios.post(`${API}/market/drivers/${appId}/transfer`, { bid_id: bidId }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketGetChat: (token, room) =>
    axios.get(`${API}/market/chat/${room}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketSendMessage: (token, data) =>
    axios.post(`${API}/market/chat`, data, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketReactMessage: (token, msgId, emoji) =>
    axios.post(`${API}/market/chat/${msgId}/react`, { emoji }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketGetThread: (token, room, parentId) =>
    axios.get(`${API}/market/chat/${room}/thread/${parentId}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketCheckBan: (data) =>
    axios.post(`${API}/market/check-ban`, data).then((r) => r.data),
  marketGetDriversFull: (token) =>
    axios.get(`${API}/market/admin/drivers-full`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketChatUploadFile: (token, file, onProgress) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/market/chat/upload`, fd, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
    }).then((r) => r.data);
  },
  marketDriverConsentToggle: (token, opted_in) =>
    axios.put(`${API}/market/driver/consent-toggle`, { opted_in }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketGetModAlerts: (token) =>
    axios.get(`${API}/market/admin/mod-alerts`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketGetHubCredentials: (token) =>
    axios.get(`${API}/market/admin/hub-credentials`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  adminGetHubCredentials: () =>
    axios.get(`${API}/admin/hub-credentials`, { headers: { Authorization: `Bearer ${getToken()}` } }).then((r) => r.data),
  marketMarkAlertRead: (token, alertId) =>
    axios.put(`${API}/market/admin/mod-alerts/${alertId}/read`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketListBans: (token) =>
    axios.get(`${API}/market/admin/bans`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketUnban: (token, banId) =>
    axios.delete(`${API}/market/admin/bans/${banId}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketCropFace: (token, appId) =>
    axios.post(`${API}/market/drivers/${appId}/crop-face`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketToggleVisibility: (token, appId, visible) =>
    axios.put(`${API}/market/drivers/${appId}/visibility`, { visible }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketUpdateDriverStatus: (token, appId, market_status) =>
    axios.put(`${API}/market/drivers/${appId}/market-status`, { market_status }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketBulkUpdateStatus: (token, driver_ids, market_status) =>
    axios.post(`${API}/market/drivers/bulk-status`, { driver_ids, market_status }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketDriverProfile: (token) =>
    axios.get(`${API}/market/driver/profile`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketDriverUploadDoc: (token, data) =>
    axios.post(`${API}/market/driver/upload-document`, data, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminEnableAllConsent: (token) =>
    axios.post(`${API}/market/admin/enable-all-consent`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminCropAllFaces: (token) =>
    axios.post(`${API}/market/admin/crop-all-faces`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminSeedDemoDrivers: (token) =>
    axios.post(`${API}/market/admin/seed-demo-drivers`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminSeedFullMarket: (token) =>
    axios.post(`${API}/market/admin/seed-full-market`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminLoadRealDrivers: (token) =>
    axios.post(`${API}/market/admin/load-real-drivers`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketDriverSetDates: (token, data) =>
    axios.post(`${API}/market/driver/set-dates`, data, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminGetBonusRequests: (token) =>
    axios.get(`${API}/market/admin/bonus-requests`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminApproveBonus: (token, app_id, bonus_type, extra = {}) =>
    axios.post(`${API}/market/admin/approve-bonus`, { app_id, bonus_type, ...extra }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminGetDriversWithDocs: (token) =>
    axios.get(`${API}/market/admin/drivers-with-docs`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminUploadDriverDoc: (token, appId, docType, filePath) =>
    axios.post(`${API}/market/admin/drivers/${appId}/upload-document`, { doc_type: docType, file_path: filePath }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminRemoveDriverDoc: (token, appId, docType) =>
    axios.delete(`${API}/market/admin/drivers/${appId}/remove-document`, { data: { doc_type: docType }, headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminViewFile: (token, path) =>
    axios.get(`${API}/market/admin/files/${path}`, { headers: { Authorization: `Bearer ${token}` }, responseType: "blob" }).then((r) => r.data),
  marketGetWinHistory: (token) =>
    axios.get(`${API}/market/admin/win-history`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketLogOutreach: (token, data) =>
    axios.post(`${API}/market/recruiter/log-outreach`, data, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketGetOutreachLog: (token) =>
    axios.get(`${API}/market/recruiter/outreach-log`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketDriverSelfApply: (data) =>
    axios.post(`${API}/market/driver/self-apply`, data).then((r) => r.data),
  marketAdminGetSelfApplyPending: (token) =>
    axios.get(`${API}/market/admin/self-apply-pending`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminReviewSelfApply: (token, appId, action) =>
    axios.post(`${API}/market/admin/self-apply/${appId}/review`, { action }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketUploadCdlFile: (token, appId, formData) =>
    axios.post(`${API}/market/recruiter/upload-cdl/${appId}`, formData, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
    }).then((r) => r.data),
  marketGetPublicProfile: (slug) =>
    axios.get(`${API}/market/drivers/public/${slug}`).then((r) => r.data),
  marketGetHiredStats: () =>
    axios.get(`${API}/market/stats/hired-this-month`).then((r) => r.data),
  marketGetCarrierLeaderboard: () =>
    axios.get(`${API}/market/carrier-leaderboard`).then((r) => r.data),
  marketSignAgreement: (token, data) =>
    axios.post(`${API}/market/carrier/sign-agreement`, data, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketSignStaffAgreement: (token, data) =>
    axios.post(`${API}/market/staff/sign-agreement`, data, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketGetMyBids: (token) =>
    axios.get(`${API}/market/driver/my-bids`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  // ── Per-account Safety Reviews ────────────────────────────────────────────
  marketSafetyMyReviews: (token) =>
    axios.get(`${API}/market/safety/my-reviews`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketSafetySetReview: (token, appId, status) =>
    axios.put(`${API}/market/safety/drivers/${appId}/review`, { status }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketSafetyBulkReview: (token, ids, status) =>
    axios.post(`${API}/market/safety/drivers/bulk-review`, { driver_ids: ids, status }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),

  marketSafetyUploadDoc: (token, appId, docType, file) => {    const fd = new FormData();
    fd.append("doc_type", docType);
    fd.append("file", file);
    return axios.post(`${API}/market/safety/drivers/${appId}/upload-doc`, fd, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
  marketDownloadDoc: (token, appId, docType) =>
    axios.get(`${API}/market/carrier/drivers/${appId}/document/${docType}`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    }).then((r) => r.data),
  marketRecruiterUpdateDriver: (token, appId, fields) =>
    axios.patch(`${API}/market/recruiter/drivers/${appId}`, fields, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),
  marketGetCashbackWallet: (token) =>
    axios.get(`${API}/market/carrier/cashback-wallet`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketDriverReferrals: (token) =>
    axios.get(`${API}/market/driver/referrals`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketReturnToMarket: (token, appId) =>
    axios.post(`${API}/market/admin/drivers/${appId}/return-to-market`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminBonusReset: (token, appId, field) =>
    axios.patch(`${API}/market/admin/drivers/${appId}/bonus-reset`, { field }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminPendingReferrals: (token) =>
    axios.get(`${API}/market/admin/referrals/pending`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminMarkReferralPaid: (token, referredAppId) =>
    axios.patch(`${API}/market/admin/referrals/${referredAppId}/mark-paid`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),

  // ── DQ Packet + DOT History ──────────────────────────────────────────────
  marketDownloadDQPacket: (token, appId) =>
    axios.get(`${API}/market/carrier/drivers/${appId}/dq-packet`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    }).then((r) => r.data),

  marketDownloadDQBundle: (token, appId) =>
    axios.get(`${API}/market/drivers/${appId}/dq-bundle`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    }).then((r) => r.data),

  marketLogOptOut: (token, appId, type) =>
    axios.post(`${API}/market/drivers/${appId}/opt-out`, { type }, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),

  marketRevokeOptOut: (token, appId) =>
    axios.delete(`${API}/market/drivers/${appId}/opt-out`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),

  marketRequestDotHistory: (token, appId) =>
    axios.post(`${API}/market/carrier/request-dot-history/${appId}`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),

  marketSubmitSupplementalHistory: (token, data) =>
    axios.put(`${API}/market/driver/supplemental-history`, data, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),

  // ── PII Cleared Flags ────────────────────────────────────────────────────
  marketPiiClearToggle: (token, appId, docType, cleared) =>
    axios.patch(`${API}/market/admin/drivers/${appId}/pii-clear/${docType}`, { cleared }, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),

  marketPiiClearAll: (token, appId) =>
    axios.post(`${API}/market/admin/drivers/${appId}/pii-clear-all`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),

  marketPiiBulkClearAll: (token) =>
    axios.post(`${API}/market/admin/pii-clear-all-drivers`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),

  // ── Tenstreet Push ───────────────────────────────────────────────────────
  marketUpdateTenstreetId: (token, companyId) =>
    axios.post(`${API}/market/carrier/tenstreet-company-id`, { tenstreet_company_id: companyId }, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),

  marketTenstreetPushStatus: (token, appId) =>
    axios.get(`${API}/market/admin/tenstreet-push/${appId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),

  // ── Carrier Profile ──────────────────────────────────────────────────────
  marketGetCarrierProfile: (token) =>
    axios.get(`${API}/market/carrier/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),
  marketUpdateCarrierProfile: (token, data) =>
    axios.put(`${API}/market/carrier/profile`, data, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),
  marketGetCarrierProfiles: (token) =>
    axios.get(`${API}/market/carrier/profiles`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),
  marketUploadCarrierFleetPhoto: (token, file, onProgress) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/market/carrier/profile/upload-photo`, fd, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
    }).then((r) => r.data);
  },
  marketDeleteCarrierFleetPhoto: (token, photoId) =>
    axios.delete(`${API}/market/carrier/profile/photo/${photoId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),

  marketUploadCarrierLogo: (token, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/market/carrier/profile/upload-logo`, fd, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },

  // ── Email Account Auth ────────────────────────────────────────────────────
  marketAccountLogin: (email, password) =>
    axios.post(`${API}/market/accounts/login`, { email, password }).then((r) => r.data),
  marketAccountForgotPassword: (email) =>
    axios.post(`${API}/market/accounts/forgot-password`, { email }).then((r) => r.data),
  marketAccountResetPassword: (token, new_password) =>
    axios.post(`${API}/market/accounts/reset-password`, { token, new_password }).then((r) => r.data),

  // ── Admin: Account Management ─────────────────────────────────────────────
  marketAdminListAccounts: (token) =>
    axios.get(`${API}/market/admin/accounts`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),
  marketAdminCreateAccount: (token, data) =>
    axios.post(`${API}/market/admin/accounts`, data, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),
  marketAdminUpdateAccount: (token, accountId, data) =>
    axios.patch(`${API}/market/admin/accounts/${accountId}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),
  marketAdminDeleteAccount: (token, accountId) =>
    axios.delete(`${API}/market/admin/accounts/${accountId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),

  // ── Google Auth ───────────────────────────────────────────────────────────
  marketGoogleAuth: (sessionId, hub = "carrier") =>
    axios.post(`${API}/market/accounts/google-auth`, { session_id: sessionId, hub }).then((r) => r.data),
  marketCarrierRegister: (data) =>
    axios.post(`${API}/market/accounts/register`, data).then((r) => r.data),
  marketGetTourContent: () =>
    axios.get(`${API}/market/tour-content`).then((r) => r.data),
  marketSaveTourContent: (token, content) =>
    axios.put(`${API}/market/admin/tour-content`, { tour_content: content }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),

  // ── Admin: Reset market days ──────────────────────────────────────────────
  marketAdminResetMarketDays: (token) =>
    axios.post(`${API}/market/admin/reset-market-days`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data),

  // ── Admin: Profile management ─────────────────────────────────────────────
  marketAdminListAllProfiles: (token) =>
    axios.get(`${API}/market/admin/all-profiles`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminDeleteDriver: (token, appId) =>
    axios.delete(`${API}/market/admin/drivers/${appId}/profile`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminDeleteCarrier: (token, carrierKey) =>
    axios.delete(`${API}/market/admin/carriers/${encodeURIComponent(carrierKey)}/profile`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminDeleteHubUser: (token, hub, userId) =>
    axios.delete(`${API}/market/admin/hub-users/${hub}/${userId}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),

  // ── Transfer payment flow ──────────────────────────────────────────────────
  marketUploadPaymentReceipt: (token, bidId, file) => {
    const fd = new FormData(); fd.append("file", file);
    return axios.post(`${API}/market/transfers/${bidId}/upload-receipt`, fd,
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  marketGetNotifications: (token) =>
    axios.get(`${API}/market/notifications`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketMarkNotificationRead: (token, notifId) =>
    axios.post(`${API}/market/notifications/${notifId}/read`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketGetUnlockedDrivers: (token) =>
    axios.get(`${API}/market/unlocked-drivers`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketGetFullDriverProfile: (token, appId) =>
    axios.get(`${API}/market/drivers/${appId}/full-profile`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminPendingReceipts: (token) =>
    axios.get(`${API}/market/admin/pending-receipts`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminFinalApprove: (token, bidId) =>
    axios.post(`${API}/market/admin/transfers/${bidId}/final-approve`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminUploadReceiptForCarrier: (token, bidId, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/market/admin/transfers/${bidId}/upload-receipt`, fd, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
  marketAdminPaymentStatus: (token) =>
    axios.get(`${API}/market/admin/payment-status`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data),
  marketAdminExportPaymentStatusCSV: (token) =>
    axios.get(`${API}/market/admin/payment-status/export-csv`, { headers: { Authorization: `Bearer ${token}`, Accept: "text/csv" }, responseType: "blob" }).then((r) => r.data),
};
